import { Row, Col } from "react-bootstrap";
import { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import FullLayout from '../layouts/FullLayout';
import { getOneUser, addingUser, updateUser } from "../services/userServices";
import Toast from 'react-bootstrap/Toast';
import { RoleContext, AlertContext } from "../utils/contexts/RoleContext";

export default function CrudDetails() {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const [userNameError, setUserNameError] = useState('');
    const [emailError, setEmailError] = useState("");
    const [phoneError, setphoneError] = useState('')
    const [passwordError, setPasswordError] = useState('');
    const [confirmPasswordError, setConfirmPasswordError] = useState("");

    const toast = useContext(AlertContext);
    
    let { id } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        if (id) {
            getOneUserCrud(id);
        }
    }, [id]);

    const getOneUserCrud = async (id) => {
        try {
            const response = await getOneUser(id);
            if (response?.status === 200) {
                const responseData = response?.data?.data;
                setName(responseData.name);
                setEmail(responseData.email);
                setPhone(responseData.phone);


            }
        } catch (error) {
            console.error("Error:", error);
        }
    };


    async function updatingUser() {
        try {
            // setLoading(true);
            const response = await updateUser(id, name, email, phone);
            console.log('response formdata', response)
            const responseData = response?.data;
            let theme = "success";
            if (response?.status === 200) {
                navigate(`/users`)
            } else {
                console.log("error", response)
                theme = "danger"
            }
            window.scrollTo(0, 0);
            toast.setToast(responseData?.message, theme);
        } catch (error) {
            // setLoading(false);
            console.error("Error:", error);
        }
    }

    //addRecord
    const addRecord = async () => {
        setUserNameError('');
        setEmailError('')
        setPasswordError('');
        setConfirmPasswordError('');
        setphoneError('')

        if (name.trim() === "") {
            setUserNameError('Enter valid full Name');
            return;
        }

        else if (email === "") {
            setEmailError('Enter valid Email');
            return;
        }
        else if (phone === '') {
            setphoneError('Enter valid Phone number');
            return;
        }
        else if (!password) {
            setPasswordError('Enter valid Password');
            return;
        }
        else if (!confirmPassword) {
            setConfirmPasswordError('Enter valid Confirm Password');
            return;
        }



        try {
            // setLoading(true);

            const response = await addingUser(name, email, phone, password, confirmPassword);
            const responseData = response?.data;
            console.log("response", responseData)
            let theme = "success";

            if (response?.status === 200) {
                navigate(`/users`)
                console.log("response", response)


            } else {
                console.log("error", response)
                theme = "danger"
            }
            window.scrollTo(0, 0);
            toast.setToast(responseData?.message, theme);
            console.log("responseData?.data", responseData?.data)
        } catch (error) {
            // setLoading(false);
            console.error("Error:", error);
        }
    };

    const handleSubmitCrud = (event) => {
        event.preventDefault();
        console.log("Form submitted with values:", { name, email, phone, password, confirmPassword });
        if (id) {
            updatingUser(id);
        } else {
            addRecord();
        }
    };
    return (
        <FullLayout>
            <div>
                <h1>{id ? "Update User" : "Add User"}</h1>
                <Col className="mt-3 mb-4">
                    <div className="add_doctor_form px-4">
                        <Form onSubmit={handleSubmitCrud}>
                            <Form.Group className="mb-3">
                                <Form.Label>Name</Form.Label>
                                <InputGroup>
                                    <Form.Control type="text" value={name} onChange={(e) => {
                                        setUserNameError('')
                                        setName(e.target.value)
                                    }} />
                                </InputGroup>
                                {userNameError ? <span className="text-danger">{userNameError}</span> : ""}

                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Email</Form.Label>
                                <InputGroup>
                                    <Form.Control type="email" value={email} onChange={(e) => {
                                        setEmailError('')
                                        setEmail(e.target.value)
                                    }} />
                                </InputGroup>
                                {emailError ? <span className="text-danger">{emailError}</span> : ""}

                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Phone</Form.Label>
                                <InputGroup>
                                    <Form.Control type="text" value={phone} onChange={(e) => {
                                        setPhone(e.target.value)
                                        setphoneError('')
                                    }
                                    } maxLength={13} />
                                </InputGroup>
                                {phoneError ? <span className="text-danger">{phoneError}</span> : ""}

                            </Form.Group>
                            {!id ?
                                <div>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Password</Form.Label>
                                        <InputGroup>
                                            <Form.Control type="password" minLength={8} value={password} onChange={(e) => {
                                                setPasswordError('')
                                                setPassword(e.target.value)
                                            }} />
                                        </InputGroup>
                                        {passwordError ? <span className="text-danger">{passwordError}</span> : ""}

                                    </Form.Group>

                                    <Form.Group className="mb-3">
                                        <Form.Label>Confirm Password</Form.Label>
                                        <InputGroup>
                                            <Form.Control type="password" value={confirmPassword} onChange={(e) => {
                                                setConfirmPasswordError('')
                                                setConfirmPassword(e.target.value)
                                            }} />
                                        </InputGroup>
                                        {confirmPasswordError ? <span className="text-danger">{confirmPasswordError}</span> : ""}

                                    </Form.Group>
                                </div>
                                : ''
                            }
                            <button className="btn_gradian ms-3 mt-3" type="submit">
                                {id ? "Update" : "Add"}
                            </button>
                        </Form>
                    </div>
                </Col>
            </div>


        </FullLayout>
    );
}